import permissions from '../../data/permissions';

export default [
    {
        name: "GoodReturnCreate",
        path: "return",
        component: () => import('./../../views/purchase/goodReturn/GoodReturnCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.good_return.create }
    },
    {
        name: "GoodReturnList",
        path: "returns",
        component: () => import('./../../views/purchase/goodReturn/GoodReturnListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.good_return.index }
    },
    {
        name: "GoodReturnDisplay",
        path: "return/:id",
        component: () => import('./../../views/purchase/goodReturn/GoodReturnDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.good_return.read }
    },
    {
        name: "GoodReturnEdit",
        path: "return/:id/edit",
        component: () => import('./../../views/purchase/goodReturn/GoodReturnEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.good_return.update }
    }
]